const Color = {
  // primary:   "#F05A23",
  primary:      "#FAA519",
  secondary:    "#F1901C",
  black:        "#000000",
  white:        "#ffffff",

  // Red
  razz:         "#D70050",
  punch:        "#DC3545",
  carnation:    "#F25969",

  // Grey
  emperor:      "#555555",
  nandor:       "#575857",
  shuttleGray:  "#5A6268",
  nobel:        "#B4B4B4",
  aluminium:    "#AAB1BB",
  mercury:      "#E6E6E6",
  athens:       "#E8EAED",
  porcelain:    "#EAECEE",
  athensGrey:   "#F2F4F7",
  aliceBlue:    "#F5F7FA",
  wildSand:     "#F5F5F5",
  heather:      "#BCBEC0",

  // Black
  nero:         "#1A1A1A",

  // Orange
  blazeOrange:  "#ff7000",
  pizazz:       "#fa8e00",

  // Green
  pistachio:    "#77CD00",

  // Blue
  denim:        "#1B75BC",
};

export default Color;
